import Utils from "../../utils/Utils";

export default {

    init() {


        const DATA_PAYMENT_ID = "payment-id";

        const INPUT_FILTER_DATE_FROM = "#input-filter-date-from";
        const INPUT_FILTER_DATE_TO = "#input-filter-date-to";

        const TABLE_DEBITS = "#table-debits";
        const TABLE_DEBITS_BODY = "#table-debits tbody";

        const TABLE_CREDITS = "#table-credits";
        const TABLE_CREDITS_BODY = "#table-credits tbody";

        const TH_DEBITS_TOTAL = "#th-debits-total";
        const TH_CREDITS_TOTAL = "#th-credits-total";

        const BTN_MARK_AS_PAID = ".btn-mark-as-paid";

        function debitsAndCreditsTotalLoaded(total) {
            $(TH_DEBITS_TOTAL).text(numeral(total.debits).format('0,0.00'));
            $(TH_CREDITS_TOTAL).text(numeral(total.credits).format('0,0.00'));
        }

        function getDebitsAndCreditsTotal(date_from, date_to) {
            const params = {
                date_from: date_from,
                date_to: date_to,
            };

            httpRequest.get(`admin/content/api/dashboard/debits-credits-total`, {
                params: params
            })
                .then(response => debitsAndCreditsTotalLoaded(response.data.data))
                .catch(error => {

                });
        }

        function paymentMarkedAsPaid(payment, callback) {

            if (callback && typeof callback === "function") {
                callback(payment);
            }
        }

        function markPaymentAsPaid(payment_id, callback) {

            httpRequest.put(`admin/content/api/payments/${payment_id}/mark-as-paid`)
                .then(response => paymentMarkedAsPaid(response.data.data, callback))
                .catch(error => {

                });
        }

        $(TABLE_DEBITS_BODY).on('click', BTN_MARK_AS_PAID, function (e) {
            e.preventDefault();
            const payment_id = $(this).data(DATA_PAYMENT_ID);

            if (!Utils.isEmpty(payment_id)) {
                markPaymentAsPaid(payment_id, function (payment) {
                    const element = $(TABLE_DEBITS_BODY).find(`tr[data-payment-id=${payment.id}]`);
                    element.remove();
                    getDebitsAndCreditsTotal($(INPUT_FILTER_DATE_FROM).val(), $(INPUT_FILTER_DATE_TO).val());
                    /*element.removeClass('table-danger');
                    element.addClass('table-success');
                    element.find(BTN_MARK_AS_PAID).hide();
                    element.find('.paid-marker').html(`<i class="font-size-18 bx bx-check"></i>`);*/

                });
            }
        });

        $(TABLE_CREDITS_BODY).on('click', BTN_MARK_AS_PAID, function (e) {
            e.preventDefault();
            const payment_id = $(this).data(DATA_PAYMENT_ID);

            if (!Utils.isEmpty(payment_id)) {
                markPaymentAsPaid(payment_id, function (payment) {
                    const element = $(TABLE_CREDITS_BODY).find(`tr[data-payment-id=${payment.id}]`);
                    element.remove();
                    getDebitsAndCreditsTotal($(INPUT_FILTER_DATE_FROM).val(), $(INPUT_FILTER_DATE_TO).val());
                    /*element.removeClass('table-danger');
                    element.addClass('table-success');
                    element.find(BTN_MARK_AS_PAID).hide();
                    element.find('.paid-marker').html(`<i class="font-size-18 bx bx-check"></i>`);*/

                });
            }
        });

        function caricaSituazioneContabileTeramo() {

            const config = {
                params: {
                    date_from: $(INPUT_FILTER_DATE_FROM).val(),
                    date_to: $(INPUT_FILTER_DATE_TO).val()
                }
            }

            httpRequest.get("admin/content/api/dashboard/situazione-contabile-teramo", config)
                .then(function (response) {
                    const spinner = document.getElementById("spinner-situazione-contabile-teramo");
                    const wrapper = document.getElementById("situazione-contabile-teramo");
                    wrapper.innerHTML = response.data.data.html;
                    spinner.style.display = "none";
                })
                .catch(function (error) {

                });
        }

        function caricaSituazioneContabileBari() {
            const config = {
                params: {
                    date_from: $(INPUT_FILTER_DATE_FROM).val(),
                    date_to: $(INPUT_FILTER_DATE_TO).val()
                }
            }

            httpRequest.get("admin/content/api/dashboard/situazione-contabile-bari", config)
                .then(function (response) {
                    const spinner = document.getElementById("spinner-situazione-contabile-bari");
                    const wrapper = document.getElementById("situazione-contabile-bari");
                    wrapper.innerHTML = response.data.data.html;
                    spinner.style.display = "none";
                })
                .catch(function (error) {

                });
        }

        caricaSituazioneContabileTeramo();
        caricaSituazioneContabileBari()

    },

    finalize() {

    },
}
